var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 32,
    viewBox: "0 0 99 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8999 31.5384H34.8802L39.8963 0.561523H47.9155L42.8999 31.5384Z",
    fill: "#00579F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.972 1.31881C70.3901 0.692035 67.8812 0 64.779 0C56.8592 0 51.2823 4.21791 51.248 10.2482C51.1823 14.6974 55.241 17.1686 58.2766 18.6521C61.3793 20.168 62.434 21.1574 62.434 22.5086C62.4025 24.5839 59.9269 25.5404 57.6179 25.5404C54.4161 25.5404 52.7005 25.0473 50.0934 23.8927L49.0373 23.3978L47.9151 30.3514C49.796 31.2072 53.2614 31.9667 56.8592 32C65.2741 32 70.7524 27.8474 70.8173 21.4211C70.8493 17.8948 68.7061 15.1928 64.0856 12.9848C61.2807 11.5675 59.5629 10.6118 59.5629 9.16157C59.5958 7.8432 61.0158 6.49286 64.1821 6.49286C66.7892 6.42672 68.7048 7.05262 70.156 7.67895L70.8813 8.00789L71.972 1.31881Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6309 20.5644C83.2913 18.7848 85.8327 11.8973 85.8327 11.8973C85.7994 11.9634 86.4918 10.0849 86.8878 8.93163L87.4483 11.6008C87.4483 11.6008 88.967 19.0156 89.2968 20.5644C88.0434 20.5644 84.2149 20.5644 82.6309 20.5644ZM92.5302 0.561523H86.3269C84.414 0.561523 82.9607 1.12128 82.1353 3.13169L70.2231 31.5379H78.6379C78.6379 31.5379 80.0233 27.7147 80.321 26.8912C81.2442 26.8912 89.4301 26.8912 90.6177 26.8912C90.8479 27.9788 91.5746 31.5379 91.5746 31.5379H99L92.5302 0.561523Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1819 0.561523L20.328 21.6848L19.4697 17.4007C18.0177 12.4575 13.4638 7.08679 8.38196 4.41633L15.5759 31.5055H24.0565L36.662 0.561523H28.1819Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0349 0.561523H0.132002L0 1.18742C10.0651 3.75802 16.731 9.95435 19.4697 17.402L16.6648 3.16541C16.203 1.18698 14.7838 0.626785 13.0349 0.561523Z",
    fill: "#FAA61A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6c1ab79c0a47a23e4d055ea747266c2a.svg";
export { ForwardRef as ReactComponent };